import { render, staticRenderFns } from "./HealthCareCardDetails.vue?vue&type=template&id=48e00431&scoped=true"
import script from "./HealthCareCardDetails.vue?vue&type=script&lang=js"
export * from "./HealthCareCardDetails.vue?vue&type=script&lang=js"
import style0 from "./HealthCareCardDetails.vue?vue&type=style&index=0&id=48e00431&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e00431",
  null
  
)

export default component.exports